import dataManagementIcon from '../../../assets/img/icon-park-outline_data-user.svg';
import dashboardIcon from '../../../assets/img/carbon_dashboard.svg';
import caseInfoIcon from '../../../assets/img/ic_outline-cases.svg';
import workspaceIcon from '../../../assets/img/fluent_open-48-filled.svg';
import importIcon from '../../../assets/img/uil_import.svg';
import analyticsIcon from '../../../assets/img/majesticons_analytics-line.svg';

export const steps = (isEditing, error) => [
    {
        title: 'Create Your Profile!',
        subtext:
            'Please take a moment to provide a few important details and input your information below.',
        contentType: 'form',
        formFields: [
            {
                label: 'First Name',
                name: 'firstName',
                placeholder: 'John',
                inputProps: { padding: 12 },
            },
            {
                label: 'Last Name',
                name: 'lastName',
                placeholder: 'Doe',
                inputProps: { padding: 12 },
            },
            {
                label: 'Phone Number',
                name: 'phoneNumber',
                placeholder: '123-456-7890',
                type: 'tel',
                inputProps: { pattern: '[0-9]*', maxLength: 12, padding: 12 },
                adornment: isEditing ? '+1' : '',
                valueFormatter: (value) => {
                    if (value && value.replace('---', '').length > 0) {
                        return `+1-${value}`;
                    } else {
                        return value;
                    }
                },

                error: error,
                helperText: error ? 'Invalid phone number' : null,
            },
            {
                label: 'Organization',
                name: 'company',
                placeholder: 'Acoer',
                inputProps: { padding: 12 },
            },
            {
                label: 'Job Title',
                name: 'jobTitle',
                placeholder: 'Developer',
                inputProps: { padding: 12 },
            },
        ],
    },
    {
        title: 'What is Health Data Explorer (HDE)?',
        subtext:
            'HDE is a cutting-edge application that transforms health insights for professionals, policymakers, and researchers. With intuitive reporting and real-time data visualization, it empowers users to harness the power of health data',
        contentType: 'feature',
        features: [
            {
                icon: dataManagementIcon,
                title: 'Centralized Data Management',
                subtext:
                    'Organize your cancer-related data, such as patient information, diagnostic and treatment data, imaging results, histology details, and scan reports, for enhanced visibility and streamlined efficiency in one secure location.',
            },
            {
                icon: dashboardIcon,
                title: 'Visual Data Dashboard',
                subtext:
                    'View quick insights into key cancer data points and trends through a detailed dashboard, enabling comprehensive analysis and the tracking of cancer care timelines, along with reporting on incidence, survival, and quality surveillance.',
            },
            {
                icon: caseInfoIcon,
                title: 'Detailed Case Information',
                subtext:
                    "Explore a real time view of investigation data and in-depth, personalized record details such as incident locations, cancer type, patient identifiers, diagnoses, treatments and outcomes in individual case views, allowing for tailored analysis of each organization's unique datasets.",
            },
        ],
    },
    {
        title: 'What Can Health Data Explorer Do For You?',
        subtext:
            'Discover what HDE has to offer by watching this brief onboarding video that highlights key functionalities.\n' +
            'Press play to begin your learning journey.',
        contentType: 'video',
        video: 'https://www.youtube.com/embed/ScnKBP6TwLk',
    },
    {
        title: 'Beta Trial Policies',
        subtext:
            'Please take a moment to review our policy for a seamless experience in the Health Data Explorer beta program.',
        contentType: 'policy',
        policyTitle: 'Welcome to the Health Data Explorer (HDE) Beta Program!',
        policyIntro:
            'Our beta program offers you the opportunity to explore our innovative SaaS platform designed to revolutionize health data management. Health Data Explorer combines intuitive reporting, robust analytics, and real-time data visualization to provide a comprehensive solution for harnessing the power of health data.',
        policies: [
            {
                title: 'Account Termination and Data Deletion Policy for Beta Trial Accounts:',
                content:
                    'Upon signing up to evaluate the platform using a Beta Trial account, please be aware that we retain the right to terminate your account and erase associated data at our discretion, without prior notice.',
            },
            {
                title: 'Use of Production Data on Unpaid Trial Accounts:',
                content:
                    'During the period of an unpaid trial account, we kindly request that you refrain from utilizing production data. We reserve the right to terminate accounts discovered to be in violation of this policy, leading to the loss of stored data within the platform upon the conclusion of the trial period.',
            },
        ],
        conclusion:
            "We hope you find your experience with Health Data Explorer informative and valuable. Should you have any questions or require assistance during your trial, please don't hesitate to reach out to our support team.",
    },
    {
        title: 'Create Your First Workspace!',
        subtext:
            'To help you get started we will create a workspace for you. Follow the steps below to view your new workspace.',
        contentType: 'feature',
        features: [
            {
                icon: workspaceIcon,
                title: 'Open Your New Workspace',
                subtext:
                    'On the homepage you will see a list of your workspace. Open the default workspace we created for you or create a new workspace.',
            },
            {
                icon: importIcon,
                title: 'Import Data',
                subtext:
                    "Utilize the 'Import Wizard' to set up your workspace with demo data or upload your own case data for immediate analytics.",
            },
            {
                icon: analyticsIcon,
                title: 'Explore Analytics And Cases',
                subtext:
                    'After successful data upload, navigate to your workspace dashboard to search and access detailed case information.',
            },
        ],
    },
];
